module.exports = __webpack_public_path__ + "3aabf345871453097c2d8762411d187e.woff";